import { useEffect, useState} from 'react';

import axios from 'axios';

const useFetchData = ({searchdata,vid,catid, setLoading}) => {
  const [data, setData] = useState({});
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await axios.get(`https://bulkify.in/api/vendor/product-list.php?vid=${vid}&catid=${catid}&searchdata=${searchdata}`);
        setData(response);
      } catch (error) {
        console.error(error)
      }
      finally{
        setLoading(false);
      }
      
    };

    fetchData();
  }, [searchdata,vid,catid, setLoading]);

  return {data};
};

export default useFetchData;